import {Tooltip} from '@material-ui/core';
import React from 'react';

import TimelapseIcon from '@material-ui/icons/Timelapse';

type RecordStatusProps = {
  count: number;
};

export const InProgressRecords = ({count}: RecordStatusProps) => {
  return (
    <div className="record-status">
      <Tooltip title={`# record(s) in progress:${count}`}>
        <TimelapseIcon className="status__processing" />
      </Tooltip>
      <span className="record-count">{count}</span>
    </div>
  );
};

export default InProgressRecords;
